import * as yup from "yup";

export const FormScheme = yup.object().shape({
  name: yup.string().required("Your name required"),
  email: yup.string().email().required("Your email required"),
  message: yup.string().required("Message required"),
});
